import * as React from "react";

import { FraudStatusIcon } from "app/components/AppComponents/Fraud";
import { formatDate } from "app/utils/filters";
import SnapminLink from "app/components/BOComponents/SnapminLink";
import { User } from "../userTypes";
import AccountDeletionRequestControl from "./AccountDeletionRequestControl";

type Props = {
  user: any;
  authedBankCardLoads: string;
  deviceCount: number;
  onUserChanged: (user: User) => void;
  refetch?: any;
};

class Details extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.onUserChanged(props.user);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.user !== this.props.user) {
      newProps.onUserChanged(newProps.user);
    }
  }

  render() {
    const { user } = this.props;

    return (
      <table
        style={{
          fontSize: "14px",
          paddingTop: "10px",
          width: "100%",
        }}
        className="BOTable"
        cellPadding={0}
        cellSpacing={0}
      >
        <thead>
          <tr>
            <td colSpan={7}>
              <h3
                style={{
                  borderBottom: "1px solid rgb(204, 204, 204)",
                  fontWeight: 400,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={{ flex: 1 }}>Details</span>
              </h3>
            </td>
          </tr>
          <tr>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Date</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Email</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Type</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Devices</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Card loads</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Fraud Status</b>
            </th>
            <th style={{ textAlign: "left" }}>
              <b style={{ color: "#555" }}>Deletion Request</b>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            style={{
              background: "#F9F9F9",
            }}
          >
            <td> {formatDate(user.created_at)} </td>
            <td>
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="blueLink"
                href={user.dashboard_url}
              >
                {user.email}
              </a>
              <SnapminLink snapminUrl={user.snapmin_url} />
            </td>
            <td> {user.group} </td>
            <td> {this.props.deviceCount} </td>
            <td> {this.props.authedBankCardLoads}</td>
            <td>
              <FraudStatusIcon fraudStatus={user.fraud_status} />
            </td>
            <td>
              <AccountDeletionRequestControl
                external_reference={this.props.user.external_reference}
                has_valid_deletion_request={
                  this.props.user.has_valid_deletion_request
                }
                latest_valid_deletion_request_status={
                  this.props.user.has_valid_deletion_request
                    ? this.props.user.latest_valid_deletion_request.status
                    : ""
                }
                refetch={this.props.refetch}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default Details;
